import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";

import {Box, TableCell, TableRow} from "@mui/material";

import VariantBadge from "components/dashboard/VariantBadge";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

import ProductImage from "../../../../TopTablesComponents/ProductImage";
import ProductDescription from "../../../../TopTablesComponents/ProductDescription";
import PriorityBadge from "./PriorityBadge";

import {black500} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

StockAlertRow.propTypes = {
    rank: PropTypes.number.isRequired,
    product: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
};

function StockAlertRow({rank, product, currency}) {
    const { id, sku, name, brand, image, variants = [], priority, alerts, lostRevenue, retailerId} = product ?? {};
    const history = useHistory();

    return (
        <TableRow
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_PRODUCT(retailerId, id), history)}
            hover
            sx={{
                "td" : {padding: '20px 10px'},
                "td:last-of-type": { paddingRight: '20px' },
                "td:first-of-type": { paddingLeft: '20px' },
                cursor: 'pointer'
            }}
        >
            <TableCell sx={{py: "20px", pl: "24px"}}>
                <ProductImage
                    rank={rank}
                    image={image}
                    name={name}
                />
            </TableCell>

            <TableCell align="left" sx={{fontSize: "14px", fontWeight: 600, color: black500}}>
                {alerts ?? 0}
            </TableCell>

            <TableCell align="left">
                <FormattedNumberWithCurrency
                    value={lostRevenue ?? 0}
                    currency={currency}
                />
            </TableCell>

            <TableCell sx={{maxWidth: 260}}>
                <Box sx={{display: "flex", flexWrap: "wrap", gap: "4px"}}>
                    {(variants ?? []).map((v, i) => (
                        <VariantBadge key={i} value={v}/>
                    ))}
                </Box>
            </TableCell>

            <TableCell sx={{maxWidth: 260}}>
                <ProductDescription
                    name={name}
                    brand={brand}
                    sku={sku}
                />
            </TableCell>

            <TableCell align="right">
                <Box sx={{display: "flex", justifyContent: "center"}}>
                    <PriorityBadge score={priority ?? 0}/>
                </Box>
            </TableCell>
        </TableRow>
    );
}

export default StockAlertRow;
